import React from 'react';
import { motion } from 'framer-motion';
import './AboutSection.css';
import Button from '../Button/Button';
import imgLeft from '../../Assets/Hero/abt (2).png';
import imgRight from '../../Assets/Hero/abt (1).png';

const About = () => {
  // SMOOTH ANIMATION VARIANTS
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1, 
      transition: { 
        staggerChildren: 0.2, // Time between each item appearing
        delayChildren: 0.1 
      } 
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 40 }, // Start lower for a smoother rise
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { 
        duration: 0.9, 
        ease: [0.22, 1, 0.36, 1] // Smooth custom cubic-bezier curve
      } 
    }
  };

  return (
    <section className="about-section">
      <motion.div 
        className="about-container"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2, margin: "0px 0px -50px 0px" }}
        variants={containerVariants}
      >
        
        {/* LEFT SIDE: Image Grid */}
        <div className="about-images">
          <motion.div className="img-box img-short" variants={itemVariants}>
            <img src={imgLeft} alt="Insulation Material" />
          </motion.div>
          <motion.div className="img-box img-tall" variants={itemVariants}>
            <img src={imgRight} alt="Insulation Board" />
          </motion.div>
        </div>

        {/* RIGHT SIDE: Text Content */}
        <div className="about-content">
          <motion.h2 variants={itemVariants}>
            <span>Annai Insulation</span> is a trusted provider of industrial insulation services and ducting solutions.
          </motion.h2>
          
          <motion.p className="about-desc" variants={itemVariants}>
            We specialize in nitrile rubber insulation and a wide range of thermal and 
            acoustic insulation materials, delivering reliable solutions at competitive 
            prices within committed timelines.
          </motion.p>

          <motion.p className="about-sub-desc" variants={itemVariants}>
            With a 9+ years of industry experience and technical expertise, we understand 
            the diverse requirements of our clients and consistently provide solutions that 
            meet the highest standards of quality and performance.
          </motion.p>

          <motion.div className="about-btn-wrapper" variants={itemVariants}>
            <Button 
              text="Learn More About Us" 
              variant="outline" 
              size="md" 
            />
          </motion.div>
        </div>

      </motion.div>
    </section>
  );
};

export default About;